import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { payersListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import usePayersList from './hooks';
import styles from './PayersList.module.scss';

function PayersList({ payersReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = usePayersList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={payersReports}
        headers={payersListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

PayersList.propTypes = {
  payersReports: PropTypes.arrayOf(
    PropTypes.shape({
      reasonCode: PropTypes.string,
      description: PropTypes.string,
      noteRequired: PropTypes.bool,
      alertType: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

PayersList.defaultProps = {
  payersReports: [],
  loading: false,
};

export default PayersList;
